import React, { useState, useRef } from "react"
import { numberWithCommas } from "utils/HelperFunc"
import ReactToPrint from "react-to-print"
import { Button } from "antd"
import * as AuthRequest from "services/auth"

export default ({
  username,
  perPage,
  from,
  to,
  service,
  allSkins,
  activeSkinId,
  provider_name,
  card,
}) => {
  const componentRef = useRef(null)
  const [localPayments, setLocalPayments] = useState([])
  const [isPdfLoading, setIsPdfLoading] = useState(false)

  const pdfFileName = `transazioni_${from}_${to}`
  const getFullData = async () => {
    setIsPdfLoading(true)
    try {
      const skinId = activeSkinId === -1 ? (allSkins ? "" : null) : activeSkinId
      const isSpecial = activeSkinId === -1 && !allSkins

      const response = await AuthRequest.fetchPayments(
        username,
        from,
        to,
        "",
        10000,
        skinId,
        "special",
        service,
        "",
        "",
        "",
        provider_name,
        activeSkinId === -1 ? true : undefined,
        card,
      )

      const rawData = response?.data?.transactions || []
      setLocalPayments(rawData)
      setIsPdfLoading(false)
      return rawData
    } catch (error) {
      console.error("Export error:", error)
      setIsPdfLoading(false)
      return []
    }
  }

  const tdStyle = { border: "1px solid #000", padding: "6px", fontSize: "10px" }
  const thStyle = {
    ...tdStyle,
    backgroundColor: "#f2f2f2",
    fontWeight: "bold",
    textAlign: "left",
  }

  return (
    <div className="exportPDF">
      <ReactToPrint
        documentTitle={pdfFileName}
        onBeforeGetContent={getFullData}
        trigger={() => (
          <Button
            loading={isPdfLoading}
            style={{ border: "none", color: "#0078ff", background: "transparent" }}
          >
            <i className="fal fa-file-pdf" style={{ marginRight: 5 }}></i>
            .Pdf
          </Button>
        )}
        content={() => componentRef.current}
      />

      <div style={{ display: "none" }}>
        <div ref={componentRef} style={{ padding: "40px", background: "#fff" }}>
          <h2>Report</h2>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={thStyle}>Date / Ora</th>
                <th style={thStyle}>Barcode</th>
                <th style={thStyle}>User</th>
                {allSkins && <th style={thStyle}>Username</th>}
                <th style={thStyle}>Service</th>
                <th style={thStyle}>Importo</th>
                <th style={thStyle}>Commissione</th>
                <th style={thStyle}>Proviggione</th>
                {!allSkins && (
                  <>
                    <th style={thStyle}>Agente</th>
                    <th style={thStyle}>Skin</th>
                    <th style={thStyle}>Sistema</th>
                    <th style={thStyle}>Saldo</th>
                  </>
                )}
              </tr>
            </thead>
            <tbody>
              {localPayments.map((pay, idx) => (
                <tr key={pay.id || idx}>
                  {allSkins ? (
                    <>
                      <td style={tdStyle}>{pay.Date_Ora}</td>
                      <td style={tdStyle}>{pay.Barcode}</td>
                      <td style={tdStyle}>{pay.User}</td>
                      <td style={tdStyle}>{pay.Username}</td>
                      <td style={tdStyle}>{pay.Service}</td>
                      <td style={tdStyle}>{pay.Importo}</td>
                      <td style={tdStyle}>{pay.Commisione}</td>
                      <td style={tdStyle}>{pay.Proviggione}</td>
                    </>
                  ) : (
                    <>
                      <td style={tdStyle}>{pay.executed_date}</td>
                      <td style={tdStyle}>{pay.barcode}</td>
                      <td style={tdStyle}>{pay.agency_name}</td>
                      <td style={tdStyle}>{pay.service_name}</td>
                      <td style={tdStyle}>
                        {pay.service_name === "Adyen" ? "-" : pay.price1000 / 100}
                      </td>
                      <td style={tdStyle}>{pay.commissione}</td>
                      <td style={tdStyle}>{pay.percentage}</td>
                      <td style={tdStyle}>{pay.agent_profit ?? "-"}</td>
                      <td style={tdStyle}>{pay.skin_profit ?? "-"}</td>
                      <td style={tdStyle}>{pay.system_aggio ?? "-"}</td>
                      <td style={tdStyle}>{pay.saldo ?? "-"}</td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
